import { render, staticRenderFns } from "./auditLicenseRequest.vue?vue&type=template&id=4dc28b21"
import script from "./auditLicenseRequest.vue?vue&type=script&lang=js"
export * from "./auditLicenseRequest.vue?vue&type=script&lang=js"
import style0 from "./auditLicenseRequest.vue?vue&type=style&index=0&id=4dc28b21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports